import React, { useState } from 'react';
import { View } from '../../../../../../Enums/View.enum';
import WorkplaceWorkersListItemGridView from './WorkplaceWorkersListItemGridView';
import WorkplaceWorkersListItemListView from './WorkplaceWorkersListItemListView';
import WorkplaceWorkerDetailModal from '../../../WorkplaceWorker/WorkplaceWorkerDetail/WorkplaceWorkerDetailModal';

export interface WorkplaceWorkerItem {
	id: string;
	email: string;
	profileImageUrl: string;
	rootWorkplaceMemberStatus: string;
	profile: {
		fullName: string;
	};
}

interface Props {
	item: WorkplaceWorkerItem;
	onRefresh: (reset?: boolean) => void;
	view: View;
	showAllWorkplaces: boolean;
}

const WorkplaceWorkersListItem: React.FC<Props> = ({
	item,
	view,
	showAllWorkplaces,
	onRefresh,
}) => {
	const [isDetailOpen, setIsDetailOpen] = useState(false);
	const handleOpenWorkerProfile = () => {
		setIsDetailOpen(true);
	};

	let component = undefined;

	if (view === View.GRID) {
		component = (
			<WorkplaceWorkersListItemGridView
				item={item}
				onClick={handleOpenWorkerProfile}
			/>
		);
	} else if (view === View.LIST) {
		component = (
			<WorkplaceWorkersListItemListView
				item={item}
				onClick={handleOpenWorkerProfile}
			/>
		);
	} else {
		return <></>;
	}

	return (
		<>
			{component}
			{isDetailOpen && (
				<WorkplaceWorkerDetailModal
					isOpen
					userId={item.id}
					onClose={() => setIsDetailOpen(false)}
					showAllWorkplaces={showAllWorkplaces}
					onWorkplaceEdit={() => onRefresh(true)}
				/>
			)}
		</>
	);
};

export default WorkplaceWorkersListItem;
